"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const Array_1 = require("fp-ts/lib/Array");
const E = require("fp-ts/lib/Either");
const pipeable_1 = require("fp-ts/lib/pipeable");
__export(require("./array"));
__export(require("./number"));
__export(require("./string"));
__export(require("./time"));
__export(require("./email"));
__export(require("./phone"));
__export(require("./euros"));
__export(require("./business-id"));
__export(require("./iban"));
__export(require("./ssn"));
__export(require("./non-nullable"));
class ValidationError {
    constructor(path, desc, info) {
        this.path = path;
        this.desc = desc;
        this.info = info;
    }
}
exports.ValidationError = ValidationError;
exports.AP = E.getValidation(Array_1.getMonoid());
exports.apFirst = pipeable_1.pipeable(exports.AP).apFirst;
class RequiredInfo {
    constructor() {
        this.type = 'required';
    }
}
exports.RequiredInfo = RequiredInfo;
